import React, { useState } from 'react';
import {
    ClickAwayListener, Grow, IconButton, Paper, Popper, Tooltip, MenuItem, MenuList,
} from '@material-ui/core';

import './GroupedIconButton.scss';

/**
 * @typedef {{
 *  value: number;
 *  label: string;
 *  action: Function;
 *  disabled?: boolean;
 * }} GroupedIconButtonOption
 *
 * @typedef {{
 *  icon: React.ReactNode;
 *  tooltipTitle?: string;
 *  buttonClassName?: string;
 *  options: GroupedIconButtonOption[];
 *  disabled?: boolean;
 * }} GroupedIconButtonProps
 */

/**
 * @param {GroupedIconButtonProps} props
 */
const GroupedIconButton = ({
    icon,
    tooltipTitle = '',
    buttonClassName = '',
    options,
    disabled = false,
}) => {
    const anchorRef = React.useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    /**
     * @param {GroupedIconButtonOption} option
     */
    const handleOptionClick = (option) => {
        option.action();
        setIsOpen(false);
    };

    return (
        <>
            <Tooltip
                title={tooltipTitle}
                arrow
                placement="bottom"
            >
                <IconButton
                    className={buttonClassName}
                    onClick={() => setIsOpen(true)}
                    disabled={disabled}
                    ref={anchorRef}
                >
                    {icon}
                </IconButton>
            </Tooltip>
            <Popper
                open={isOpen}
                anchorEl={anchorRef.current}
                placement="bottom-start"
                transition
                style={{ zIndex: 1300 }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'right bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={() => setIsOpen(false)}>
                                <MenuList>
                                    {options.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            onClick={() => handleOptionClick(option)}
                                            disabled={option.disabled}
                                        >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

export default GroupedIconButton;
